import { render, staticRenderFns } from "./ChampionshipsList.vue?vue&type=template&id=10739cd7&scoped=true&functional=true&"
import script from "./ChampionshipsList.vue?vue&type=script&lang=js&"
export * from "./ChampionshipsList.vue?vue&type=script&lang=js&"
import style0 from "./ChampionshipsList.vue?vue&type=style&index=0&id=10739cd7&lang=scss&scoped=true&"
import style1 from "./ChampionshipsList.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  "10739cd7",
  null
  
)

export default component.exports